<nav class="nav-bar-header">
    <img src="assets/icons/seller-logo.png" class="app-logo" alt="app-logo" />
    <span class="cursor-pointer" pRipple (click)="toggleSideBar()">
        <i class="pi pi-bars text-3xl"></i>
    </span>
</nav>

<p-sidebar [(visible)]="sidebarVisible" position="right">
    <app-side-bar></app-side-bar>
</p-sidebar>
